<template lang="pug">
v-card-actions.d-flex.flex-wrap
  v-chip.mr-2.mb-2(
    v-for="item in chips"
    :key="item.key"
    close-icon="delete"
    color="primary"
    filter
    close
    small
    @click:close="$emit('delete', item.key)"
  ) {{ item.val }}
</template>

<script>
export default {
  props: {
    search: { type: Object, default: () => ({}) },
  },
  computed: {
    chips() {
      const chips = Object.entries(this.search).filter((item) => item[1]);
      return chips.map(([key, val]) => {
        let text;
        if (typeof val === 'string') text = val;
        else {
          const name = Object.keys(val).find((nameKey) => nameKey.includes('name'));
          text = val[name];
        }
        return {
          key,
          val: text,
        };
      });
    },
  },
};
</script>
